// LoginContentV2 Component

import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import IntlUtil from '../../../lib/intlutil.jsx'
import Alert from '../../common/alert/alert.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import Checkbox from '../../form/checkbox/checkbox.jsx'
import InputAlt from '../../form/input_alt/input_alt.jsx'
import { Spinner } from '../../common/spinner'

const SubmitButton = ({ onSubmit, isLoading, textKey }) => {
  return (
    <button
      disabled={isLoading}
      type='submit'
      className='submit'
      onClick={onSubmit}
    >
      {
        isLoading ? (
          <Spinner size={20} color='white' />
        ) : (
          <IntlMessage ident={textKey} />
        )
      }
    </button>
  )
}
class LoginContentV2 extends Component {
  static get propTypes () {
    return {
      reset: PropTypes.bool,
      showForgot: PropTypes.bool,
      onClickLogin: PropTypes.func,
      onClickForgot: PropTypes.func,
      onForgot: PropTypes.func,
      onLogin: PropTypes.func,
      onReset: PropTypes.func,
      title: PropTypes.string,
      resetEmail: PropTypes.string,
      isLoading: PropTypes.bool,
      setIsLoading: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      reset: false,
      showForgot: false,
      onClickLogin: null,
      onClickForgot: null,
      onForgot: null,
      onLogin: null,
      onReset: null,
      title: '',
      resetEmail: '',
      setIsLoading: null
    }
  }

  constructor (props) {
    super(props)

    this.state = {
      bLogin: !props.reset,
      bForgot: props.showForgot,
      bReset: props.reset,
      successReset: '',
      bSuccess: false,
      bAnimateContent: false,
      name: '',
      email: props.resetEmail ? props.resetEmail : '',
      password: '',
      bRememberMe: true,
      confirmPassword: '',
      showError: false,
      isPasswordError: false,
      errors: {},
      forgotEmailError: false
    }

    this._references = {
      inputEmail: React.createRef(),
      inputResetPassword: React.createRef(),
      inputForgotEmail: React.createRef(),
      inputPassword: React.createRef(),
      inputResetEmail: React.createRef(),
      inputResetConfirmPassword: React.createRef(),
      alert: React.createRef()
    }
  }

  componentDidMount () {
    if (this._references.inputEmail.current) {
      this._references.inputEmail.current.focus()
    }

    if (this._references.inputResetPassword.current) {
      this._references.inputResetPassword.current.focus()
    }
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (!this.state.bForgot && nextState.bForgot) {
      this.bFocus = true
    }

    return true
  }

  componentDidUpdate () {
    this.setAutoFocus()
  }

  // eslint-disable-next-line camelcase
  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.resetEmail && this.state.email !== nextProps.resetEmail) {
      this.setState({ email: nextProps.resetEmail })
    } else if (this.state.bForgot !== nextProps.showForgot) {
      this.setState({ bForgot: nextProps.showForgot })
    }
  }

  setAutoFocus () {
    if (this.bFocus) {
      this.bFocus = false

      if (this._references.inputForgotEmail.current) {
        this._references.inputForgotEmail.current.focus()
      }
    }
  }

  render () {
    const contentClass = classnames('login-contentv2', {
      'login-content_animatecont': this.state.bAnimateContent,
      'login-content_animateall': !this.state.bAnimateContent
    })

    return (
      <div className={contentClass}>
        <div className='logincontainerv2'>
          <div className='content'>
            <div className='header'>
              <img src='/images/common/rodeo_logo.svg' alt='logo' className='logo' />
            </div>

            {this.state.bLogin && this._renderLoginForm()}
            {this.state.bForgot && this._renderForgotForm()}
            {this.state.bReset && this._renderResetForm()}
          </div>
        </div>
        <Alert ref={this._references.alert} />
      </div>
    )
  }

  showLogin () {
    this._clearForm()
    this.setState({ bLogin: true, bForgot: false, bReset: false })
  }

  /* Event Handlers */
  _onChangeInput (name, value) {
    this.setState({ [name]: value })
  }

  _onBlurField (name) {
    this.setState(prevState => ({
      ...prevState,
      errors: {
        ...prevState.errors,
        [name]: false
      }
    }))
  }

  _onSubmitForgot (ev) {
    ev.preventDefault()

    const invalidEmailError = !this._references.inputForgotEmail?.current?.validate()

    this.setState({
      forgotEmailError: invalidEmailError
    })

    this.props.setIsLoading(true)

    if (
      !invalidEmailError &&
      this.props.onForgot &&
      this._references.inputForgotEmail.current
    ) {
      this.props.onForgot(this._references.inputForgotEmail.current.getValue())
    } else {
      this.props.setIsLoading(false)
    }
  }

  _onClickPrevious (ev) {
    ev.preventDefault()

    this._clearForm()
    this.setState({
      bLogin: true,
      bForgot: false,
      bReset: false,
      bAnimateContent: true
    })
  }

  _onClickForgot (ev) {
    ev.preventDefault()

    this._clearForm()
    this.setState({
      bLogin: false,
      bForgot: true,
      bReset: false,
      bAnimateContent: false
    })
  }

  _onSubmitLogin (ev) {
    ev.preventDefault()

    const refs = this._references

    const errors = {
      email: !refs.inputEmail?.current?.validate(),
      password: !refs.inputPassword?.current?.validate()
    }

    this.setState(prevState => ({
      ...prevState,
      errors
    }))
    this.props.setIsLoading(true)

    const hasErrors = Object.values(errors).filter(error => error).length

    if (!hasErrors) {
      if (
        this.props.onLogin &&
        this._references.inputEmail.current &&
        this._references.inputPassword.current
      ) {
        this.props.onLogin(
          this._references.inputEmail.current.getValue(),
          this._references.inputPassword.current.getValue(),
          this.state.bRememberMe
        )
      }
    } else {
      this.props.setIsLoading(false)
    }
  }

  _onSubmitReset (ev) {
    ev.preventDefault()

    let noErrors = 0

    this.props.setIsLoading(true)

    if (
      this._references.inputResetEmail.current &&
      !this._references.inputResetEmail.current.validate()
    ) {
      this.showError('user.reset.msgEmailError')
      noErrors++
    } else if (
      this._references.inputResetPassword.current &&
      !this._references.inputResetPassword.current.validate()
    ) {
      this.showError('user.reset.msgInvalidPassword')
      noErrors++
    } else if (
      this._references.inputResetConfirmPassword.current &&
      !this._references.inputResetConfirmPassword.current.validate()
    ) {
      this.showError('user.reset.msgInvalidConfirmPassword')
      noErrors++
    } else if (
      this._references.inputResetPassword.current &&
      this._references.inputResetConfirmPassword.current &&
      this._references.inputResetPassword.current.getValue() !==
        this._references.inputResetConfirmPassword.current.getValue()
    ) {
      this.showError('user.reset.msgMismatchError')
      noErrors++
    }

    if (noErrors === 0) {
      if (
        this.props.onReset &&
        this._references.inputResetEmail.current &&
        this._references.inputResetPassword.current
      ) {
        this.props.onReset(
          this._references.inputResetEmail.current.getValue(),
          this._references.inputResetPassword.current.getValue()
        )
      }
    } else {
      this.props.setIsLoading(false)
    }
  }

  showError (msgIdent) {
    if (this._references.alert.current) {
      this._references.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'error'
      )
    }
  }

  showSuccess (msgIdent) {
    if (this._references.alert.current) {
      this._references.alert.current.onShow(
        IntlUtil.convertMessage(msgIdent),
        'success'
      )
    }
  }

  showLoginError (errLogin = 'user.login.msgInvalidValues') {
    this.showError(errLogin)
  }

  showForgotError () {
    this.showError('user.forgot.msgForgotErrorContent')
  }

  showResetError () {
    this.showError('user.reset.msgEmailError')
  }

  showTeamError () {
    this.showError('user.login.msgInvalidTeams')
  }

  showForgotSuccess () {
    this.showSuccess('user.login.msgResetLink')
    this.setState({
      bLogin: true,
      bForgot: false,
      bReset: false,
      bAnimateContent: true,
      bSuccess: true
    })
  }

  showResetSuccess () {
    this.setState({
      successReset: 'user.profile.msgSuccessPassword',
      email: '',
      password: '',
      confirmPassword: ''
    })
  }

  /* Private Functions */
  _clearForm () {
    // Clear Inputs
    if (this._references.inputResetEmail.current) {
      this._references.inputEmail.current.clear()
    }
    if (this._references.inputPassword.current) {
      this._references.inputPassword.current.clear()
    }
    if (this._references.inputForgotEmail.current) {
      this._references.inputForgotEmail.current.clear()
    }
    if (this._references.inputResetPassword.current) {
      this._references.inputResetPassword.current.clear()
    }
    if (this._references.inputResetConfirmPassword.current) {
      this._references.inputResetConfirmPassword.current.clear()
    }

    this.setState({
      bSuccess: false
    })
  }

  _renderInfo (title, content, bShow) {
    const _className = classnames('typo', {
      active: bShow
    })
    return (
      <div className={_className}>
        <h1 className='title'>
          <IntlMessage ident={title} />
        </h1>
        <div className='content'>
          <p>
            <IntlMessage ident={content} />
          </p>
        </div>
        {this._renderPreviousButton()}
      </div>
    )
  }

  _renderPreviousButton () {
    if (this.state.bForgot) {
      return (
        <IconButton
          icon='login-previous'
          title='user.login.tipLogin'
          canHover={false}
          onClick={this._onClickPrevious.bind(this)}
        />
      )
    }

    return null
  }

  _renderLoginForm () {
    if (this.state.bReset || this.state.bForgot) {
      return null
    }

    const formClass = classnames('loginformv2', {
      loginform_show: this.state.bLogin,
      loginform_animatecont: this.state.bAnimateContent,
      loginform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitLogin.bind(this)}
        >
          <div className='formheader'>
            <h2 className='title'>
              <IntlMessage ident='user.login.loginTitle' />
            </h2>
            <div className='content'>
              <IntlMessage ident='user.login.loginTitleInfo' />
            </div>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.login.usernameLabel' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='email'
                  size={10}
                  maxLength={100}
                  label='user.login.enterUserNamePlaceholder'
                  ref={this._references.inputEmail}
                  required
                  validations={['required', 'email']}
                  sanitizers={['trim']}
                  value={this.state.email}
                  onChange={this._onChangeInput.bind(this, 'email')}
                  onBlur={this._onBlurField.bind(this, 'email')}
                  className={this.state.errors?.email ? 'error' : ''}
                />
              </div>
            </div>
            <div className='formrow reduced-margin'>
              <div className='formfield'>
                <div className='formlabel'>
                  <IntlMessage ident='user.login.passwordLabel' />
                </div>
                <InputAlt
                  type='password'
                  name='password'
                  size={10}
                  maxLength={100}
                  label='user.login.enterPasswordPlaceholder'
                  ref={this._references.inputPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.password}
                  onChange={this._onChangeInput.bind(this, 'password')}
                  className={this.state.errors?.password ? 'error' : ''}
                  onBlur={this._onBlurField.bind(this, 'password')}
                  allowShowPassword
                />
              </div>
            </div>
            <div className='formrow'>
              <a
                href='/forgot-password'
                title={IntlUtil.convertMessage(
                  'user.login.tipForgotPassword'
                )}
                className='formlink'
                onClick={this.props.onClickForgot}
              >
                <IntlMessage ident='user.login.forgotPassword' />
              </a>
            </div>
            <div className='formrowcheck'>
              <div className='formfield'>
                <Checkbox
                  label='user.login.keepLoggedin'
                  checked={this.state.bRememberMe}
                  icon='login'
                  onChange={this._onChangeInput.bind(this, 'bRememberMe')}
                />
              </div>
            </div>
            <div className='formrowact'>
              <SubmitButton
                onSubmit={this._onSubmitLogin.bind(this)}
                isLoading={this.props.isLoading}
                textKey='user.login.loginToRodeo'
              />
            </div>
          </div>
        </form>
        <img
          src='/images/common/signup_info.png'
          alt='Invoice'
          className='inline-image'
        />
      </div>
    )
  }

  _renderForgotForm () {
    if (this.state.bReset) {
      return ''
    }

    const formClass = classnames('forgotformv2', {
      forgotform_show: this.state.bForgot,
      forgotform_animatecont: this.state.bAnimateContent,
      forgotform_animateall: this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitForgot.bind(this)}
        >
          <div className='formheader'>
            <h2 className='title'>
              <IntlMessage ident='user.forgot.titlev2' />
            </h2>
            <div className='content'>
              <p>
                <IntlMessage ident='user.forgot.subInfov2' />
              </p>
            </div>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.forgot.emailv2' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='email'
                  maxLength={100}
                  label='user.forgot.emailPlaceholderv2'
                  ref={this._references.inputForgotEmail}
                  required
                  validations={['required', 'email']}
                  sanitizers={['trim']}
                  value={this.state.email}
                  onChange={this._onChangeInput.bind(this, 'email')}
                  onBlur={() => this.setState({ forgotEmailError: false })}
                  className={this.state.forgotEmailError ? 'error' : ''}
                />
              </div>
            </div>
          </div>
          <div className='loginsubmit'>
            <SubmitButton
              onSubmit={this._onSubmitForgot.bind(this)}
              isLoading={this.props.isLoading}
              textKey='user.forgot.submitv2'
            />
          </div>
          <div
            className='loginprevious'
            onClick={this.props.onClickLogin}
          >
            <IntlMessage ident='user.forgot.contentpreviousv2' />
          </div>
        </form>
        <img
          src='/images/common/signup_info.png'
          alt='Invoice'
          className='inline-image'
        />
      </div>
    )
  }

  _renderResetForm () {
    const formClass = classnames('resetform', {
      resetform_show: this.state.bReset,
      resetform_animatecont: this.state.bAnimateContent,
      resetform_animateall: !this.state.bAnimateContent
    })

    return (
      <div className={formClass}>
        <form
          action='#'
          method='post'
          noValidate
          onSubmit={this._onSubmitReset.bind(this)}
        >
          <div className='formheader'>
            <h2 className='title'>
              <IntlMessage ident='user.reset.title' />
            </h2>
          </div>
          <div className='formcontent'>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.reset.usernameLabel' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='text'
                  name='email'
                  maxLength={120}
                  label='user.reset.emailPlaceholder'
                  ref={this._references.inputResetEmail}
                  required
                  validations={['required', 'email']}
                  sanitizers={['trim']}
                  value={this.state.email}
                  onChange={this._onChangeInput.bind(this, 'email')}
                  onBlur={this._onBlurField.bind(this, 'email')}
                  className={this.state.errors?.email ? 'error' : ''}
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.reset.passwordLabel' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='password'
                  maxLength={100}
                  label='user.reset.passwordPlaceholder'
                  ref={this._references.inputResetPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.password}
                  onChange={this._onChangeInput.bind(this, 'password')}
                  className={this.state.errors?.password ? 'error' : ''}
                  onBlur={this._onBlurField.bind(this, 'password')}
                  allowShowPassword
                />
              </div>
            </div>
            <div className='formrow'>
              <div className='formlabel'>
                <IntlMessage ident='user.reset.confirmPasswordLabel' />
              </div>
              <div className='formfield'>
                <InputAlt
                  type='password'
                  name='confirm_password'
                  maxLength={100}
                  label='user.reset.confirmPasswordPlaceholder'
                  ref={this._references.inputResetConfirmPassword}
                  required
                  validations={['required', 'password']}
                  value={this.state.confirmPassword}
                  onChange={this._onChangeInput.bind(this, 'confirmPassword')}
                  className={this.state.errors?.password ? 'error' : ''}
                  onBlur={this._onBlurField.bind(this, 'confirmPassword')}
                  allowShowPassword
                />
              </div>
            </div>
          </div>
          <div className='formrowact'>
            <SubmitButton
              onSubmit={this._onSubmitReset.bind(this)}
              isLoading={this.props.isLoading}
              textKey='user.reset.tipSend'
            />
          </div>
        </form>
        <img
          src='/images/common/signup_info.png'
          alt='Invoice'
          className='inline-image'
        />
      </div>
    )
  }
}

export default LoginContentV2
